import { HttpService } from '@/shared/services'
import List from '@/shared/dtos/List'
import CalendarGroup from '../models/CalendarGroup'
import WorkingDay from '../models/WorkingDay'
import CreateCalendarGroupDto from '../services/dtos/CreateCalendarGroupDto'
import UpdateCalendarGroupDto from '../services/dtos/UpdateCalendarGroupDto'
const http = new HttpService()

export const getCalendarGroupsByPayrollConfigId = async (
  payrollConfigId: string,
  search?: string
) => {
  let url = `/calendarGroup/${payrollConfigId}`

  if (search !== undefined && search !== null && search !== '') {
    url = url + `?search=${search}`
  }

  const response = await http.get<List<CalendarGroup[]>>(url)

  return response.data
}

export const getCalendarGroupById = async (id: string) => {
  const response = await http.get<CalendarGroup>(`/calendarGroup/detail/${id}`)

  return response.data
}

export const createCalendarGroup = async (dto: CreateCalendarGroupDto) => {
  const response = await http.post<CreateCalendarGroupDto, string>(
    `/calendarGroup`,
    dto
  )

  return response.data
}

export const updateCalendarGroup = async (dto: UpdateCalendarGroupDto) => {
  console.log(dto)
  const response = await http.put<UpdateCalendarGroupDto, string>(
    `/calendarGroup/${dto.id}`,
    dto
  )

  return response.data
}

export const deleteCalendarGroup = async (id: string) => {
  const response = await http.delete<string>(`/calendarGroup/${id}`)

  return response.data
}

export const getWorkingDays = async () => {
  const response = await http.get<WorkingDay[]>(`/workingDays`)

  return response.data
}
